<div class="loading-modal">
  <div class="box-modal">


    <div class="box-text">
      <h1>{{ modalPasosCampanaContent()?.title }}</h1>

      <div class="row">

        <!-- Paso 1 -->
        <div class="column">
          <img src="/assets/icons/office_bag.svg" alt="Icono" class="icon" />

          <span class="textPrimary">
            <svg class="icon-number" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="12" fill="var(--primaryColor)" />
              <path
                d="M13.2158 17H11.9854V9.15918C11.6891 9.44173 11.2995 9.72428 10.8164 10.0068C10.3379 10.2894 9.90723 10.5013 9.52441 10.6426V9.45312C10.2126 9.12956 10.8141 8.73763 11.3291 8.27734C11.8441 7.81706 12.2087 7.37044 12.4229 6.9375H13.2158V17Z"
                fill="white" />
            </svg>
            {{ modalPasosCampanaContent()?.registerClientFirstStep }}
          </span>
        </div>

        <div class="icon-1"></div>

        <!-- Paso 2 -->
        <div class="column">
          <img src="/assets/icons/centros_trabajo.svg" alt="Icono" class="icon" />

          <span>
            <img src="/assets/icons/2.2.svg" alt="Número 2" class="icon-number" />
            {{ modalPasosCampanaContent()?.createDepartmentThirdStep }}
          </span>
        </div>

        <div class="icon-1"></div>

        <!-- Paso 3 -->
        <div class="column">
          <img src="/assets/icons/worker.svg" alt="Icono" class="icon" />

          <span>
            <img src="/assets/icons/3.2.svg" alt="Número 3" class="icon-number" />
            {{ modalPasosCampanaContent()?.createOcupationSecondStep }}
          </span>
        </div>

        <div class="icon-1"></div>

        <!-- Paso 4 -->
        <div class="column">
          <img src="/assets/icons/calendar.svg" alt="Icono" class="icon" />

          <span>
            <img src="/assets/icons/4.2.svg" alt="Número 4" class="icon-number" />
            {{ modalPasosCampanaContent()?.createCampaignFourthStep }}
          </span>
        </div>
      </div>


      <button class="button" (click)="onClose()">{{ modalPasosCampanaContent()?.confirmButton }}</button>
    </div>

  </div>
</div>
